import { FC } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface ButtonInfoDialogProps {
  isOpen: boolean;
  onClose: () => void;
  modalDetails: {
    [key: string]: {
      title: string;
      description: string | JSX.Element;
      detailsRequired: boolean;
      detailsText: string;
      rteOptionalText?: string;
    };
  };
}

const ButtonInfoDialog: FC<ButtonInfoDialogProps> = ({
  isOpen,
  onClose,
  modalDetails,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Action Button Information</DialogTitle>
      <DialogContent>
        {Object.entries(modalDetails).map(([key, value]) => (
          <div key={key}>
            <Typography variant="h6">{value.title}</Typography>
            <Typography>{value.description}</Typography>
            <br />
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ButtonInfoDialog;
